module.exports = __webpack_public_path__ + "static/media/banner-marcha-jesus-2022.c136e2fe.png";